module.exports = __webpack_public_path__ + "img/articulo-box.7632f0c1.png";